<!-- Display mode -->
<div class="form-group element-view" *ngIf="!element.editing">
  <button class="btn btn-primary btn-sm element-edit-button"
          (click)="enterEditMode()">
    Edit Element
  </button>

  <!-- Display text / Policy -->
  <div *ngIf="(element.element_type === DocumentElementType.displayText) || (element.element_type === DocumentElementType.policy)"
       [innerHtml]="markdownRenderService.getRenderedMarkdown(element.parameters.content)"></div>

  <!-- Video -->
  <div *ngIf="element.element_type === DocumentElementType.video"
       [innerHtml]="getVideoEmbedCode()"></div>

  <!-- Signature -->
  <div *ngIf="element.element_type === DocumentElementType.signature">
    <input type="text" class="form-control form-control-lg my-2 text-center" disabled
           style="font-family: cursive">
    <button type="button" class="btn btn-primary btn-block">
      Signature
    </button>
  </div>

  <!-- Generic Capitan inputs -->
  <div *ngIf="CapitanGenericDocumentElementTypes.includes(element.element_type)">
    <label>
      {{ getDocumentElementTypeDisplay(element.element_type) }} <span *ngIf="element.parameters.required">*</span>
    </label>
    <input type="text" class="form-control pb-1">
    <ng-container *ngIf="element.parameters.include_marketing_opt_in">
      <div class="form-check mt-2">
        <input type="checkbox" class="form-check-input" [defaultChecked]="orgConfig.email_opt_in_is_selected_by_default">
        <label class="form-check-label" [innerHTML]="markdownRenderService.getRenderedInlineMarkdown(orgConfig.email_opt_in_checkbox_text)">
          Opt in to marketing and promotional emails
        </label>
      </div>
      <small class="form-text text-muted" *ngIf="orgConfig.email_opt_in_help_text"
             [innerHTML]="markdownRenderService.getRenderedMarkdown(orgConfig.email_opt_in_help_text)">
      </small>
    </ng-container>
    <p *ngIf="element.parameters.include_mailchimp_groups && !!orgConfig.mailchimp_audience_id"
       class="text-muted mt-2">
      Mailchimp group questions will be inserted here.
    </p>
  </div>

  <!-- Birthday -->
  <div *ngIf="element.element_type === DocumentElementType.capitanBirthday">
    <label class="mb-0">Birthday  <span *ngIf="element.parameters.required">*</span></label>
    <div class="row">
      <div class="col-4">
        <label for="inputBirthdayDay" class="text-small mb-1">Day</label>
        <input class="form-control" id="inputBirthdayDay" name="birthday-day"
               type="number" min="1" max="31" step="1">
      </div>
      <div class="col-4">
        <label for="inputBirthdayMonth" class="text-small mb-1">Month</label>
        <select class="custom-select" id="inputBirthdayMonth" name="birthday-month">
          <option value="1">January</option>
          <option value="2">February</option>
          <option value="3">March</option>
          <option value="4">April</option>
          <option value="5">May</option>
          <option value="6">June</option>
          <option value="7">July</option>
          <option value="8">August</option>
          <option value="9">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>
      </div>
      <div class="col-4">
        <label for="inputBirthdayYear" class="text-small mb-1">Year</label>
        <input class="form-control" id="inputBirthdayYear" name="birthday-year"
               type="number" min="1900" step="1">
      </div>
    </div>
  </div>

  <!-- Address -->
  <div *ngIf="element.element_type === DocumentElementType.capitanAddress">
    <div *ngIf="!element.parameters.post_code_only">
      <label>Street Address 1<span *ngIf="element.parameters.required">*</span></label>
      <input type="text" class="form-control pb-1">
    </div>
    <div *ngIf="!element.parameters.post_code_only">
      <label>Street Address 2</label>
      <input type="text" class="form-control pb-1">
    </div>
    <div *ngIf="!element.parameters.post_code_only" class="mt-2">
      <label>City <span *ngIf="element.parameters.required">*</span></label>
      <input type="text" class="form-control pb-1">
    </div>

    <div *ngIf="!element.parameters.post_code_only" class="mt-2">
      <label for="stateSelect">State/Province</label>
      <select id="stateSelect" class="custom-select" name="state">
        <option value="">---</option>
        <option *ngFor="let stateOption of StateCodes" [ngValue]="stateOption.code">
          {{ stateOption.name }}
        </option>
      </select>
    </div>

    <div *ngIf="!element.parameters.post_code_only" class="mt-2">
      <label for="countrySelect">Country <span *ngIf="element.parameters.required">*</span></label>
      <select id="countrySelect" class="custom-select" name="country">
        <option *ngFor="let countryOption of CountryCodes" [ngValue]="countryOption.code">
          {{ countryOption.name }}
        </option>
      </select>
    </div>

    <div class="mt-2">
      <label>Postcode/Zip Code <span *ngIf="element.parameters.required">*</span></label>
      <input type="text" class="form-control pb-1">
    </div>
  </div>

  <!-- Emergency contact -->
  <ng-container *ngIf="element.element_type === DocumentElementType.capitanEmergencyContact">
    <ng-container *ngFor="let x of [].constructor(element.parameters.number_of_contacts); let contactIdx = index;">
      <label class="pt-2">
        Emergency Contact <span *ngIf="element.parameters.number_of_contacts > 1">#{{ contactIdx+1 }}</span>
        First Name <span *ngIf="element.parameters.required">*</span>
      </label>
      <input type="text" class="form-control pb-1">
      <label class="pt-2">
        Emergency Contact <span *ngIf="element.parameters.number_of_contacts > 1">#{{ contactIdx+1 }}</span>
        Last Name <span *ngIf="element.parameters.required">*</span>
      </label>
      <input type="text" class="form-control pb-1">
      <label class="pt-2">
        Emergency Contact <span *ngIf="element.parameters.number_of_contacts > 1">#{{ contactIdx+1 }}</span>
        Phone Number <span *ngIf="element.parameters.required">*</span>
      </label>
      <input type="text" class="form-control pb-1">
      <ng-container *ngIf="element.parameters.collect_email">
        <label class="pt-2">
        Emergency Contact <span *ngIf="element.parameters.number_of_contacts > 1">#{{ contactIdx+1 }}</span>
        Email <span *ngIf="element.parameters.required">*</span>
        </label>
        <input type="text" class="form-control pb-1">
      </ng-container>
      <ng-container *ngIf="element.parameters.collect_relation">
        <label class="pt-2">
        Emergency Contact <span *ngIf="element.parameters.number_of_contacts > 1">#{{ contactIdx+1 }}</span>
        Relation <span *ngIf="element.parameters.required">*</span>
        </label>
        <input type="text" class="form-control pb-1">
      </ng-container>
    </ng-container>
  </ng-container>

  <!-- Customer photo -->
  <div *ngIf="element.element_type === DocumentElementType.capitanCustomerPhoto">
    <label>
      Customer Photo <span *ngIf="element.parameters.required">*</span>
    </label>
    <div class="element-camera">
      <span data-feather="camera"></span>
    </div>
  </div>

  <!-- Medical notes -->
  <div *ngIf="element.element_type === DocumentElementType.capitanMedicalNotes">
    <label>
      Medical Notes <span *ngIf="element.parameters.required">*</span>
    </label>
    <textarea class="form-control pb-1"></textarea>
  </div>

  <!-- Gender -->
  <div *ngIf="element.element_type === DocumentElementType.capitanGender">
    <label>
      Gender <span *ngIf="element.parameters.required">*</span>
    </label>
    <button type="button" class="btn btn-outline-secondary btn-block">
      Male
    </button>
    <button type="button" class="btn btn-outline-secondary btn-block">
      Female
    </button>
    <button type="button" class="btn btn-outline-secondary btn-block">
      Non-binary
    </button>
    <button type="button" class="btn btn-outline-secondary btn-block">
      Prefer not to say
    </button>
  </div>

  <!-- Relationship (Minors Only) -->
  <div *ngIf="element.element_type === DocumentElementType.relationship">
    <label>
      What is the Adult's relationship to the minor?
      <span *ngIf="element.parameters.required">*</span>
    </label>
    <button type="button" class="btn btn-outline-secondary btn-block"
            *ngIf="orgConfig && orgConfig.parent_relation_allowed">
      Parent
    </button>
    <button type="button" class="btn btn-outline-secondary btn-block"
            *ngIf="orgConfig && orgConfig.legal_guardian_relation_allowed">
      Legal Guardian
    </button>
    <button type="button" class="btn btn-outline-secondary btn-block"
            *ngIf="orgConfig && orgConfig.guardian_relation_allowed">
      Guardian
    </button>
    <button type="button" class="btn btn-outline-secondary btn-block"
            *ngIf="orgConfig && orgConfig.other_relation_allowed">
      Other
    </button>
  </div>

  <!-- Short text input -->
  <ng-container *ngIf="element.element_type === DocumentElementType.shortText">
    <label>
      {{ element.parameters.label_text }} <span *ngIf="element.parameters.required">*</span>
    </label>
    <input type="text" class="form-control pb-1">
  </ng-container>

  <!-- Paragraph input -->
  <ng-container *ngIf="element.element_type === DocumentElementType.paragraphInput">
    <label>
      {{ element.parameters.label_text }} <span *ngIf="element.parameters.required">*</span>
    </label>
    <textarea class="form-control pb-1" rows="4"></textarea>
  </ng-container>

  <!-- Single checkbox -->
  <ng-container *ngIf="element.element_type === DocumentElementType.singleCheckbox">
    <div class="form-check">
      <input class="form-check-input" type="checkbox">
      <label class="form-check-label"
             [innerHtml]="markdownRenderService.getRenderedMarkdown(element.parameters.checkbox_text)"></label>
    </div>
  </ng-container>

  <!-- Quiz question -->
  <ng-container *ngIf="element.element_type === DocumentElementType.quizQuestion">
    <label>
      {{ element.parameters.question_text }}
    </label>
    <div class="form-check" *ngFor="let choice of element.parameters.question_choices; let choiceIdx = index">
      <input class="form-check-input" type="radio"
             [id]="'question' + elementId + 'c' + choiceIdx"
             [name]="'question' + elementId"
             [value]="choice">
      <label class="form-check-label" [for]="'question' + elementId + 'c' + choiceIdx">
        {{ choice }}
      </label>
    </div>
  </ng-container>

  <!-- Custom customer field -->
  <ng-container *ngIf="element.element_type === DocumentElementType.customCustomerField">

    <ng-container *ngIf="element.parameters.field_type === CustomCustomerFieldType.checkboxes">
      <label *ngIf="element.parameters.name !== ''">
        {{ element.parameters.name }} <span *ngIf="element.parameters.required">*</span>
      </label>
      <div class="form-check" *ngFor="let option of element.parameters.options; index as idx">
        <input class="form-check-input" type="checkbox"
               name="customFieldCHK{{ element.parameters.field_id }}-{{ idx }}"
               id="customFieldCHK{{ element.parameters.field_id }}-{{ idx }}">
        <label class="form-check-label" for="customFieldCHK{{ element.parameters.field_id }}-{{ idx }}">
          {{ option }}
        </label>
      </div>
    </ng-container>

    <ng-container *ngIf="element.parameters.field_type === CustomCustomerFieldType.dropdown">
      <label *ngIf="element.parameters.name !== ''"
             for="customFieldDRP{{ element.parameters.field_id }}">
        {{ element.parameters.name }} <span *ngIf="element.parameters.required">*</span>
      </label>
      <select class="custom-select"
              id="customFieldDRP{{ element.parameters.field_id }}"
              name="customFieldDRP{{ element.parameters.field_id }}">
        <option *ngFor="let option of element.parameters.options">
          {{ option }}
        </option>
      </select>
    </ng-container>

    <ng-container *ngIf="element.parameters.field_type === CustomCustomerFieldType.radio">
      <label *ngIf="element.parameters.name !== ''">
        {{ element.parameters.name }} <span *ngIf="element.parameters.required">*</span>
      </label>
      <div class="form-check" *ngFor="let option of element.parameters.options; index as idx">
        <input class="form-check-input" type="radio"
               id="customFieldRDO{{ element.parameters.field_id }}-{{ idx }}"
               name="customFieldRDO{{ element.parameters.field_id }}">
        <label class="form-check-label" for="customFieldRDO{{ element.parameters.field_id }}-{{ idx }}">
          {{ option }}
        </label>
      </div>
    </ng-container>

    <ng-container *ngIf="element.parameters.field_type === CustomCustomerFieldType.singleLineText">
      <label for="customFieldSLT{{ element.parameters.field_id }}">{{ element.parameters.name }}</label>
      <input id="customFieldSLT{{ element.parameters.field_id }}"
             name="customFieldSLT{{ element.parameters.field_id }}"
             type="text" class="form-control" maxlength="127">
    </ng-container>

    <ng-container *ngIf="element.parameters.field_type === CustomCustomerFieldType.multipleLineText">
      <label for="customFieldMLT{{ element.parameters.field_id }}">{{ element.parameters.name }}</label>
      <textarea id="customFieldMLT{{ element.parameters.field_id }}"
                name="customFieldMLT{{ element.parameters.field_id }}"
                class="form-control"></textarea>
    </ng-container>

  </ng-container>

  <!-- Help text -->
  <small class="form-text text-muted"
         *ngIf="element.parameters.help_text">
    {{ element.parameters.help_text }}
  </small>
</div>

<!-- Edit mode -->
<div class="form-group pl-2" *ngIf="element.editing">
  <label><b>
    {{ getDocumentElementTypeDisplay(element.element_type) }}
    <ng-container *ngIf="(element.element_type === DocumentElementType.customCustomerField) && (element.parameters.name !== '')">
      - {{ element.parameters.name }}
    </ng-container>
  </b></label>

  <!-- Display text -->
  <app-markdown-editor *ngIf="element.element_type === DocumentElementType.displayText"
                       [id]="elementId"
                       [(content)]="element.parameters.content">
  </app-markdown-editor>

  <!-- Video -->
  <div class="form-group" *ngIf="element.element_type === DocumentElementType.video">
    <label [for]="elementId + 'videoembed'">Video Embed Code</label>
    <textarea [id]="elementId + 'videoembed'" class="form-control" rows="3"
              [(ngModel)]="element.parameters.video_embed_code" (ngModelChange)="unsavedChanges.emit()"></textarea>
    <small class="form-text text-muted">
      Capitan supports videos hosted on
      <a href="https://support.google.com/youtube/answer/171780"
         target="_blank">YouTube</a>
      and
      <a href="https://vimeo.zendesk.com/hc/en-us/articles/224969968-Embedding-videos-overview"
         target="_blank">Vimeo</a>.
    </small>
  </div>

  <!-- Signature -->
  <ng-container *ngIf="element.element_type === DocumentElementType.signature">
    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input"
             [(ngModel)]="element.parameters.required"
             (ngModelChange)="unsavedChanges.emit()"
             [id]="elementId + 'required'">
      <label class="form-check-label" [for]="elementId + 'required'">
        Required?
      </label>
    </div>
  </ng-container>

  <!-- Generic Capitan inputs -->
  <ng-container *ngIf="CapitanDocumentElementTypes.includes(element.element_type)">
    <div class="form-group form-check"
         *ngIf="!ClimberInfoRequiredDocumentElementTypes.includes(element.element_type) || (element.element_type === DocumentElementType.capitanEmailAddress)">
      <input type="checkbox" class="form-check-input"
             [(ngModel)]="element.parameters.required"
             (ngModelChange)="unsavedChanges.emit()"
             [id]="elementId + 'required'">
      <label class="form-check-label" [for]="elementId + 'required'">
        <span *ngIf="element.element_type === DocumentElementType.capitanEmailAddress">Required for all users?</span>
        <span *ngIf="element.element_type !== DocumentElementType.capitanEmailAddress">Required?</span>
      </label>
      <small class="form-text text-muted" *ngIf="element.element_type === DocumentElementType.capitanEmailAddress">
        Marking this as required means that regardless of age, all participants will need an email address. Those under the organization's minimum age will not receive an invite to create a Capitan login. If this is not marked as required, emails will only be required for those over the organization's minimum age.
      </small>
    </div>
    <ng-container *ngIf="orgConfig && orgConfig.display_email_opt_in && (element.element_type === DocumentElementType.capitanEmailAddress)">
      <div class="form-group form-check">
        <input type="checkbox" class="form-check-input"
               [(ngModel)]="element.parameters.include_marketing_opt_in"
               (ngModelChange)="unsavedChanges.emit()"
               [id]="elementId + 'include_marketing_opt_in'">
        <label class="form-check-label" [for]="elementId + 'include_marketing_opt_in'">
          Include option to let customers opt in to marketing and promotional emails
        </label>
        <small class="form-text text-muted">
          The email opt-in checkbox text, help text, and initial state (checked vs not checked) may be configured in the
          <a target="_blank" routerLink="/organization-settings">
            Organization Settings page
          </a>.
        </small>
      </div>
      <div class="form-group form-check"
           *ngIf="!!orgConfig.mailchimp_audience_id">
        <input type="checkbox" class="form-check-input"
               [(ngModel)]="element.parameters.include_mailchimp_groups"
               (ngModelChange)="unsavedChanges.emit()"
               [id]="elementId + 'include_mailchimp_groups'">
        <label class="form-check-label" [for]="elementId + 'include_mailchimp_groups'">
          Include questions for Mailchimp groups
        </label>
        <small class="form-text text-muted">
          This will add questions for each of your configured Mailchimp groups. The answers to these questions will be synced to Mailchimp. Customers may also edit their Mailchimp groups via the Climber App Settings page.
        </small>
      </div>
    </ng-container>
    <div class="form-group">
      <label [for]="elementId + 'help'">Help Text</label>
      <input type="text" class="form-control"
             [id]="elementId + 'help'"
             [(ngModel)]="element.parameters.help_text"
             (ngModelChange)="unsavedChanges.emit()">
    </div>
  </ng-container>

  <!-- Address -->
  <div class="form-group"
       *ngIf="element.element_type === DocumentElementType.capitanAddress">
    <div class="form-check">
      <input type="checkbox" class="form-check-input"
             [(ngModel)]="element.parameters.post_code_only"
             (ngModelChange)="unsavedChanges.emit()"
             [id]="elementId + 'postcodeonly'">
      <label class="form-check-label" [for]="elementId + 'postcodeonly'">
        Postcode/Zip Code only?
      </label>
    </div>
    <small class="form-text text-muted">
      If selected, only the postcode/zip code will be gathered. Leave this unchecked to gather full addresses.
    </small>
  </div>

  <!-- Emergency contact -->
  <ng-container *ngIf="element.element_type === DocumentElementType.capitanEmergencyContact">
  <div class="form-group">
    <label [for]="elementId + 'numemerg'">Number of emergency contacts *</label>
    <select [id]="elementId + 'numemerg'" class="custom-select"
            [(ngModel)]="element.parameters.number_of_contacts"
            (ngModelChange)="unsavedChanges.emit()">
      <option [ngValue]="1">1</option>
      <option [ngValue]="2">2</option>
    </select>
  </div>
  <div class="form-text">
    Additional information collected for each emergency contact
  </div>
  <div class="form-text text-muted mt-0">
    First name, last name, and phone number will be collected for each emergency contact
  </div>
  <div class="form-check">
    <input class="form-check-input" type="checkbox"
           [(ngModel)]="element.parameters.collect_email"
           (ngModelChange)="unsavedChanges.emit()"
           [id]="elementId + 'addemail'">
    <label class="form-check-label" [for]="elementId + 'addemail'">
      Email
    </label>
  </div>
  <div class="form-check">
    <input class="form-check-input" type="checkbox"
           [(ngModel)]="element.parameters.collect_relation"
           (ngModelChange)="unsavedChanges.emit()"
           [id]="elementId + 'addrel'">
    <label class="form-check-label" [for]="elementId + 'addrel'">
      Relation
    </label>
  </div>
  </ng-container>

  <!-- Short text input -->
  <ng-container *ngIf="element.element_type === DocumentElementType.shortText">
    <div class="form-group">
      <label [for]="elementId + 'label'">Label Text</label>
      <input type="text" class="form-control"
             [id]="elementId + 'label'"
             [(ngModel)]="element.parameters.label_text"
             (ngModelChange)="unsavedChanges.emit()">
    </div>
    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input"
             [(ngModel)]="element.parameters.required"
             (ngModelChange)="unsavedChanges.emit()"
             [id]="elementId + 'required'">
      <label class="form-check-label" [for]="elementId + 'required'">
        Required?
      </label>
    </div>
    <div class="form-group">
      <label [for]="elementId + 'help'">Help Text</label>
      <input type="text" class="form-control"
             [id]="elementId + 'help'"
             [(ngModel)]="element.parameters.help_text"
             (ngModelChange)="unsavedChanges.emit()">
    </div>
  </ng-container>

  <!-- Paragraph input -->
  <ng-container *ngIf="element.element_type === DocumentElementType.paragraphInput">
    <div class="form-group">
      <label [for]="elementId + 'label'">Label Text</label>
      <input type="text" class="form-control"
             [id]="elementId + 'label'"
             [(ngModel)]="element.parameters.label_text"
             (ngModelChange)="unsavedChanges.emit()">
    </div>
    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input"
             [(ngModel)]="element.parameters.required"
             (ngModelChange)="unsavedChanges.emit()"
             [id]="elementId + 'required'">
      <label class="form-check-label" [for]="elementId + 'required'">
        Required?
      </label>
    </div>
    <div class="form-group">
      <label [for]="elementId + 'help'">Help Text</label>
      <input type="text" class="form-control"
             [id]="elementId + 'help'"
             [(ngModel)]="element.parameters.help_text"
             (ngModelChange)="unsavedChanges.emit()">
    </div>
  </ng-container>

  <!-- Single checkbox -->
  <div class="form-group"
       *ngIf="element.element_type === DocumentElementType.singleCheckbox">
    <label [for]="elementId + 'checkboxtext'">Checkbox Text</label>
    <app-markdown-editor-single-line [id]="elementId + 'checkboxtext'"
                                     [(content)]="element.parameters.checkbox_text"></app-markdown-editor-single-line>
  </div>
  <div class="form-group form-check"
       *ngIf="element.element_type === DocumentElementType.singleCheckbox">
    <input type="checkbox" class="form-check-input"
           [(ngModel)]="element.parameters.required"
           (ngModelChange)="unsavedChanges.emit()"
           [id]="elementId + 'required'">
    <label class="form-check-label" [for]="elementId + 'required'">
      Required?
    </label>
  </div>
  <div class="form-group"
       *ngIf="element.element_type === DocumentElementType.singleCheckbox">
    <label [for]="elementId + 'help'">Help Text</label>
    <input type="text" class="form-control"
           [id]="elementId + 'help'"
           [(ngModel)]="element.parameters.help_text"
           (ngModelChange)="unsavedChanges.emit()">
  </div>

  <!-- Quiz question -->
  <div class="form-group"
       *ngIf="element.element_type === DocumentElementType.quizQuestion">
    <label [for]="elementId + 'question'">Question Text</label>
    <input type="text" class="form-control"
           [id]="elementId + 'question'"
           [(ngModel)]="element.parameters.question_text"
           (ngModelChange)="unsavedChanges.emit()">
  </div>
  <div class="form-group form-check"
       *ngIf="element.element_type === DocumentElementType.quizQuestion">
    <input type="checkbox" class="form-check-input"
           [(ngModel)]="element.parameters.required"
           (ngModelChange)="unsavedChanges.emit()"
           [id]="elementId + 'required'">
    <label class="form-check-label" [for]="elementId + 'required'">
      Required?
    </label>
  </div>
  <div class="form-group"
       *ngIf="element.element_type === DocumentElementType.quizQuestion">
    <label [for]="elementId + 'help'">Help Text</label>
    <input type="text" class="form-control"
           [id]="elementId + 'help'"
           [(ngModel)]="element.parameters.help_text"
           (ngModelChange)="unsavedChanges.emit()">
  </div>
  <div class="form-group"
       *ngIf="element.element_type === DocumentElementType.quizQuestion">
    <label>Choices</label>
    <div *ngFor="let choice of element.parameters.question_choices; let choiceIdx = index; trackBy: questionChoiceTrackByFn"
         class="mb-2 ml-2">
      <div class="w-50 d-inline-block">
        <div class="input-group input-group-sm">
          <input type="text" class="form-control form-control-sm"
                 [(ngModel)]="element.parameters.question_choices[choiceIdx]"
                 (ngModelChange)="unsavedChanges.emit()">
          <div class="input-group-append">
            <span class="input-group-text text-danger"
                  *ngIf="!element.parameters.question_correct_answers.includes(choice)">
              Incorrect
            </span>
            <span class="input-group-text text-success"
                  *ngIf="element.parameters.question_correct_answers.includes(choice)">
              Correct
            </span>
          </div>
        </div>
      </div>
      <button class="btn btn-outline-dark btn-sm d-inline-block ml-2 question-choice-button"
              *ngIf="!element.parameters.question_correct_answers.includes(choice)"
              (click)="element.parameters.question_correct_answers.push(choice); unsavedChanges.emit();">
        Mark as Correct
      </button>
      <button class="btn btn-outline-dark btn-sm d-inline-block ml-2 question-choice-button"
              *ngIf="element.parameters.question_correct_answers.includes(choice)"
              (click)="element.parameters.question_correct_answers.splice(element.parameters.question_correct_answers.indexOf(choice), 1); unsavedChanges.emit();">
        Mark as Incorrect
      </button>
      <button class="btn btn-outline-danger btn-sm d-inline-block ml-2 question-choice-button"
              (click)="element.parameters.question_choices.splice(choiceIdx, 1); unsavedChanges.emit();">
        X
      </button>
    </div>
    <button class="btn btn-primary btn-sm ml-2 d-block"
            (click)="element.parameters.question_choices.push(''); unsavedChanges.emit();">
      Add Choice
    </button>
  </div>

  <!-- Custom customer field -->
  <ng-container *ngIf="element.element_type === DocumentElementType.customCustomerField">
    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input"
             [(ngModel)]="element.parameters.required"
             (ngModelChange)="unsavedChanges.emit()"
             [id]="elementId + 'required'">
      <label class="form-check-label" [for]="elementId + 'required'">
        Required?
      </label>
    </div>
    <div class="form-group">
      <label [for]="elementId + 'help'">Help Text</label>
      <input type="text" class="form-control"
             [id]="elementId + 'help'"
             [(ngModel)]="element.parameters.help_text"
             (ngModelChange)="unsavedChanges.emit()">
    </div>
  </ng-container>

  <div class="row my-2">
    <div class="col">
      <button class="btn btn-secondary btn-sm mr-2"
              [disabled]="!canMoveUp"
              [class.disabled]="!canMoveUp"
              (click)="moveUp.emit()">
        &uarr; Move Element Up
      </button>
      <button class="btn btn-secondary btn-sm"
              [disabled]="!canMoveDown"
              [class.disabled]="!canMoveDown"
              (click)="moveDown.emit()">
        &darr; Move Element Down
      </button>
    </div>
  </div>

  <button class="btn btn-primary" (click)="exitEditMode()">
    Save Element
  </button>

  <button class="btn btn-danger float-right"
          *ngIf="canRemove"
          (click)="remove.emit()">
    Remove Element
  </button>

  <button class="btn btn-danger disabled float-right" disabled
          *ngIf="!canRemove">
    Element Required
  </button>

</div>
